var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg28(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11719 11.0885H3.52895V16.0297H4.94072V11.0885H6.35248V9.67676H2.11719V11.0885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88132 9.67676C8.7136 9.67676 7.76367 10.6267 7.76367 11.7944V13.9121C7.76367 15.0797 8.7136 16.0297 9.88132 16.0297C11.049 16.0297 11.999 15.0797 11.999 13.9121V11.7944C11.999 10.6267 11.049 9.67676 9.88132 9.67676ZM10.5872 13.9121C10.5872 14.3013 10.2705 14.6179 9.88132 14.6179C9.4921 14.6179 9.17544 14.3013 9.17544 13.9121V11.7944C9.17544 11.4052 9.4921 11.0885 9.88132 11.0885C10.2705 11.0885 10.5872 11.4052 10.5872 11.7944V13.9121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8239 9.67676H13.4121V16.0297H16.9415V14.6179H14.8239V9.67676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7633 14.6179V9.67676H18.3516V16.0297H21.881V14.6179H19.7633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17521 5.44118C9.17521 5.05195 9.49187 4.73529 9.88109 4.73529H14.1164C14.5057 4.73529 14.8223 5.05195 14.8223 5.44118V8.26471H21.1752V5.44118C21.1752 2.71661 18.9586 0.5 16.234 0.5H7.76344C5.03888 0.5 2.82227 2.71661 2.82227 5.44118V8.26471H9.17521V5.44118ZM19.7634 6.85294H16.234V5.44118H19.7634V6.85294ZM7.76344 1.91176H16.234C17.6783 1.91176 18.9221 2.78419 19.4679 4.02941H15.6931C15.3051 3.59652 14.7421 3.32353 14.1164 3.32353H9.88109C9.25535 3.32353 8.69238 3.59652 8.30438 4.02941H4.52961C5.07535 2.78419 6.31911 1.91176 7.76344 1.91176ZM7.76344 6.85294H4.23403V5.44118H7.76344V6.85294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9766 24.5002H21.506V23.0885H19.3883V21.6767H20.8001V20.2649H19.3883V18.8532H21.506V17.4414H17.9766V24.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0352 24.5002H16.5646V23.0885H14.4469V21.6767H15.8587V20.2649H14.4469V18.8532H16.5646V17.4414H13.0352V24.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44727 24.5002H3.85903V21.6767H5.2708V20.2649H3.85903V18.8532H5.97668V17.4414H2.44727V24.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52985 17.4414H7.38867V24.5002H8.80044V21.6767H9.52985C9.91907 21.6767 10.2122 21.9934 10.2122 22.3826V24.5002H11.624V22.3826C11.624 21.8406 11.4308 21.3458 11.0948 20.9708C11.4309 20.5959 11.6416 20.101 11.6416 19.5591C11.6416 18.3914 10.6976 17.4414 9.52985 17.4414ZM8.80044 20.2649V18.8532H9.52985C9.91907 18.8532 10.2357 19.1698 10.2357 19.5591C10.2357 19.9483 9.91907 20.2649 9.52985 20.2649H8.80044Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg28);
export default __webpack_public_path__ + "static/media/28.3e679cf415bca564e8569c3d371db52e.svg";
export { ForwardRef as ReactComponent };